import { ReactElement } from "react";
import styles from "./VirtualList.module.less";

export const EndOfListSpacing = (): ReactElement => {
	return (
		<div className={styles.endOfListSpacing} />
	);
};
EndOfListSpacing.displayName = "VirtualList.EndOfListSpacing";